import {
  Mail,
  PlaneTakeoff,
  TrainFront,
  Building,
  ChevronDown,
  MapPin,
} from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DestinationDetailsBanlieue, DestinationDetailsParis } from "@/lib/utils";

type DestinationDropDownProps = {
  dropDownDestination: string;
  setDataFromDropDown: (destinationOption: string, destinationDetail: string, destination: string) => void;
};

export function DropdownMenuDemo({
  dropDownDestination,
  setDataFromDropDown,
}: DestinationDropDownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="items-center justify-start">
        <Button variant="outline">
          <ChevronDown className="mr-2 h-4 w-4" />
          {dropDownDestination}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 bg-white">
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuSub>
            <DropdownMenuSubTrigger>
              <Building className="mr-2 h-4 w-4" />
              <span>Paris</span>
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent className="w-56 bg-white">
                {DestinationDetailsParis.map(({ value, name }) => (
                  <DropdownMenuItem key={value} 
                    onClick={() => setDataFromDropDown('0', value, `Paris ${name}`)}>
                    <Mail className="mr-2 h-4 w-4" />
                    <span>{name}</span>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>

          <DropdownMenuSeparator />

          <DropdownMenuItem onClick={() => setDataFromDropDown('3', '0', "Gare du Nord, Gare de Est")}>
            <TrainFront className="mr-2 h-4 w-4" />
            <span>Gare du Nord, Gare de Est</span>
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => setDataFromDropDown('5', '0',"Gare Montparnasse")}>
            <TrainFront className="mr-2 h-4 w-4" />
            <span>Gare Montparnasse</span>
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => setDataFromDropDown('6', '0',"Gare de Lyon")}>
            <TrainFront className="mr-2 h-4 w-4" />
            <span>Gare de Lyon</span>
          </DropdownMenuItem>

          <DropdownMenuSeparator />

          <DropdownMenuItem onClick={() => setDataFromDropDown('2', '0',"Aéroport Charles de Gaulle")}>
            <PlaneTakeoff className="mr-2 h-4 w-4" />
            <span>Aéroport Charles de Gaulle</span>
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => setDataFromDropDown('1', '0',"Aéroport Orly")}>
            <PlaneTakeoff className="mr-2 h-4 w-4" />
            <span>Aéroport Orly</span>
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => setDataFromDropDown('A', '0',"Aéroport Beauvais")}>
            <PlaneTakeoff className="mr-2 h-4 w-4" />
            <span>Aéroport Beauvais</span>
          </DropdownMenuItem>


        </DropdownMenuGroup>

        <DropdownMenuSeparator />

        <DropdownMenuSub>
            <DropdownMenuSubTrigger>
              <Building className="mr-2 h-4 w-4" />
              <span>Banlieue</span>
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent className="w-56 bg-white">
                {DestinationDetailsBanlieue.map(({ value, name }) => (
                  <DropdownMenuItem 
                    key={value}
                    onClick={() => setDataFromDropDown('4', value, name)}>
                    <Mail className="mr-2 h-4 w-4" />
                    <span>{name}</span>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>


          <DropdownMenuGroup>

          <DropdownMenuItem onClick={() => setDataFromDropDown('8', '0',"Parc Asterix")}>
            <MapPin className="mr-2 h-4 w-4" />
            <span>Parc Asterix</span>
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => setDataFromDropDown('9', '0',"Disney")}>
            <MapPin className="mr-2 h-4 w-4" />
            <span>Disney</span>
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => setDataFromDropDown('7', '0',"Versailles")}>
            <MapPin className="mr-2 h-4 w-4" />
            <span>Versailles</span>
          </DropdownMenuItem>

        </DropdownMenuGroup>

      </DropdownMenuContent>
    </DropdownMenu>
  );
}
